import { FileText, Loader2 } from "lucide-react";
import { DataSourceType } from "../../../models/SoribotSource";

export const OfficeNoteIcon: React.FC = () => {
  return <img src='/assets/icon/officenote-icon.png'
    style={{
      marginRight: 10, verticalAlign: 'text-top'
    }} />;
}

export const PDFIcon: React.FC = () => {
  return <img src={`/assets/icon/file-extension-icon/ic-file-pdf-40.svg`}
    style={{
      width: 20, height: 20, marginRight: 10, verticalAlign: 'text-top'
    }} />;
}

export const RoomMemoIcon: React.FC = () => {
  return <FileText className="w-5 h-5 text-muted-foreground" />;
}

export const SourceDocIcon: React.FC = () => {
  return <FileText className="w-5 h-5 text-primary" />;
}


export const SpinnerIcon: React.FC<{ slot?: 'start' | 'end', className?: string }> = ({ slot, className }) => {
  return <Loader2 className={`w-4 h-4 animate-spin ${className ?? ''}`} />;
}

export function DataSourceIcon(type: DataSourceType) {
  switch (type) {
    case 'room-item': return <RoomMemoIcon />;
    case 'officenote-page': return <OfficeNoteIcon />;
    case 'file-bot-upload': return <PDFIcon />;
    case 'source-doc': return <SourceDocIcon />;
    default: return null;
  }
}